export interface User {
  admin?: boolean;
  isAd: boolean;
  address?: Address;
  category: string;
  city: string;
  costCenter: string;
  dependency: string;
  dni: string;
  email: string;
  enterprise: string;
  fullName: string;
  leaseInfo: LeaseInfoRestDTO[];
  mobile?: string;
  nis: string;
  planEntryDate: Date | string;
  postalCode: string;
  profile?: string;
  pssFinalDate: Date | string;
  telephone: string;
  groupType: string;
  department: Department;
  permissions: string;
  id?: string;
  authorizer?: string;
  workPlace?: string;
  leasing?: boolean;
  contact?: Contact;
  privacyPolicyAccepted?: boolean;
  commercialCommunicationsConsent?: boolean;
}

export interface Contact {
  phoneNumber?: string;
  mobileNumber?: string;
  leasingNumber?: string;
}

export interface Address {
  city?: string;
  countryCode?: string;
  postalCode?: string;
  stateCode?: string;
  street?: string;
  roadType?: string;
  roadNumber?: string;
  roadComplement?: string;
}

export interface LeaseInfoRestDTO {
  type: string;
  maxValue: number;
}

export interface AdminUsers {
  nis: string;
  fullName: string;
  category: string;
  mail: string;
  phone: string;
}

export interface Department {
  id: string;
  acronym: string;
  name: string;
  costCenter: string;
}

export interface AuthorizerUsers {
  fullName: string;
  id: string;
}

export enum Collective {
  PSS = 'PSS',
  EXP = 'EXP',
  FAMILY = 'FAMILY',
  OTHERS = 'OTHERS',
  EXT = 'EXT',
  EXTERNVO = 'EXTERNVO',
  RETIREE = 'RETIREE',
  COMPANY = 'COMPANYVO'
}

export interface Country {
  name: string;
  code: string;
}

export interface State {
  name: string;
  code: string;
}
